const hostname = window.location.hostname;

const DASHBOARD_HOSTS = [
  "dash.linksquire.com",
  "dash.sqir.link",
  "localhost",
];

export const isDashboard = DASHBOARD_HOSTS.includes(hostname);

export const DASHBOARD_URL = "https://dash.linksquire.com";

// Get the base URL for short links
export function getBaseUrl() {
  return process.env.REACT_APP_BASE_URL || "https://sqir.link";
}
